function DrugVO(id, name, commonName, form, strength, packing, packingCapacity, packages, availabilityCategory) {
    this.id = id;
    this.name = name;
    this.commonName = commonName;
    this.form = form;
    this.strength = strength;
    this.packing = packing;
    this.packingCapacity = packingCapacity;
    this.packages = packages;
    this.availabilityCategory = availabilityCategory;

    var _typeContext = {
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
